import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=7df54a60&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=7df54a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df54a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df54a60')) {
      api.createRecord('7df54a60', component.options)
    } else {
      api.reload('7df54a60', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=7df54a60&scoped=true&", function () {
      api.rerender('7df54a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/ResetPassword.vue"
export default component.exports